import "../script/azure-storage.blob.min.js";
import { guid, getStore, uncompileStr } from '../config/mUtils';

export const uploadFileToBlobStorage = (file, containerName, blobStorageSASKey, callback) => {
    let uploadResult = {
        isSuccess:false,
        errorMessage:"",
        data:null
    };

    let configStr = getStore("blobStorageConfig");
    if (!configStr){
        uploadResult.errorMessage = "上传设置未配置，请重新登录";
        callback(uploadResult);
        return;
    }

    let configObj = JSON.parse(uncompileStr(configStr));

    let blobStorageAccountName = configObj.AccountName;
    let domainName = configObj.DomainName;
    let blobStorageURL = "https://" + blobStorageAccountName + domainName;

    if(file == null){
        uploadResult.errorMessage = "请选择要上传的文件";
        callback(uploadResult);
    }

    if(containerName == null || containerName == ""){
        uploadResult.errorMessage = "上传容器未选择";
        callback(uploadResult);
    }

    let fileExtension = file.name.substr(file.name.lastIndexOf('.'));
    let uploadFileName = guid() + fileExtension;

    const blobService = AzureStorage.Blob.createBlobServiceWithSas(blobStorageURL, blobStorageSASKey);
    containerName = containerName.toLowerCase();

    var createBlockBlobFromBrowserFile = function(){
        blobService.createBlockBlobFromBrowserFile(containerName, uploadFileName, file, (cbfberror, cres) => {

            if(cbfberror) {
                uploadResult.errorMessage = "文件上传出错" + cbfberror.message;
            } else {
                uploadResult.isSuccess = true;
                uploadResult.data = cres;
            }
            callback(uploadResult);
        });
    }

  blobService.doesContainerExist(containerName, (exerror, exres) => {

        if(exerror){
            uploadResult.errorMessage = "网络错误"; //"容器检查时出错";
            callback(uploadResult);
        }else{
            if(exres.exists){
                createBlockBlobFromBrowserFile();
            }else{
                blobService.createContainer(containerName, (ccerror, result) => {
                    if(ccerror){
                        uploadResult.errorMessage = "创建时容器出错";
                        callback(uploadResult);
                    }else{
                        createBlockBlobFromBrowserFile();
                    }
                });
            }
        }
    });
}

export const uploadBufferToBlobStorage = (fileName, contentType, buffer, containerName, blobStorageSASKey, callback) => {
  var uploadResult = {
    isSuccess: false,
    errorMessage: "",
    data: null
  };

  var configStr = getStore("blobStorageConfig");
  if (!configStr) {
    uploadResult.errorMessage = "上传设置未配置，请重新登录";
    callback(uploadResult);
    return;
  }

  var configObj = JSON.parse(uncompileStr(configStr));

  var blobStorageAccountName = configObj.AccountName;
  var domainName = configObj.DomainName;
  var blobStorageURL = "https://" + blobStorageAccountName + domainName;

  if (fileName == null) {
    uploadResult.errorMessage = "请选择要上传的文件名称";
    callback(uploadResult);
  }

  if (containerName == null || containerName == "") {
    uploadResult.errorMessage = "上传容器未选择";
    callback(uploadResult);
  }

  var fileExtension = fileName.substr(fileName.lastIndexOf('.'));
  var uploadFileName = guid() + fileExtension;

  var blobService = AzureStorage.Blob.createBlobServiceWithSas(blobStorageURL, blobStorageSASKey);
  containerName = containerName.toLowerCase();

  var createBlockBlobFromText = function () {
    blobService.createBlockBlobFromText(containerName, uploadFileName, buffer, { contentType: contentType }, (cbfberror, cres) => {

      if (cbfberror) {
        uploadResult.errorMessage = "文件上传出错" + cbfberror.message;
      } else {
        uploadResult.isSuccess = true;
        uploadResult.data = {
            originalFileName: fileName,
            blobFile: cres
        };
      }
      callback(uploadResult);
    });
  };

  blobService.doesContainerExist(containerName, (exerror, exres) => {
    if (exerror) {
      uploadResult.errorMessage = "网络错误"; //"容器检查时出错";
      callback(uploadResult);
    } else {
      if (exres.exists) {
        createBlockBlobFromText();
      } else {
        blobService.createContainer(containerName, (ccerror, result) => {
          if (ccerror) {
            uploadResult.errorMessage = "创建时容器出错";
            callback(uploadResult);
          } else {
            createBlockBlobFromText();
          }
        });
      }
    }
  });
};



// WEBPACK FOOTER //
// ./src/filters/blobStorage.js